module.exports = __webpack_public_path__ + "static/media/so-algo--cow1.52936bd8.jpg";